import { useQuerySubscription } from "react-datocms"
import { useRouter } from "next/router"
import { getAllRecords, getSubscription, queries, request } from "@data/datocms"
import { loadOptionsData } from "@data/options"
import { datoModels } from "@data/static"
import InformationPage from "@components/static/InformationPage/InformationPage"
import Layout from "@components/structure/Layout/layout"
import Seo from "@components/structure/Seo/Seo"
import NotFoundPage from "./404"

const InfoPage = ({ subscription, options, seo }) => {
  const router = useRouter()

  if (!router.isFallback && !subscription) {
    return <NotFoundPage options={options} seo={seo} />
  }

  const {
    data: { infoPage },
  } = useQuerySubscription(subscription)

  return (
    <Layout options={options}>
      <Seo global={seo} title={infoPage.title} />
      <InformationPage title={infoPage.title} body={infoPage.content} />
    </Layout>
  )
}

export async function getStaticProps({ params }) {
  const seo = await request({ query: `{ ${queries.seo} }` })
  const options = await loadOptionsData()

  const graphqlRequest = {
    query: `
      query InfoPageData($slug: String) {
        ${queries.seo}
        infoPage(filter: {slug: {eq: $slug}}) {
          ${queries.infoPage.query}
        }
      }
    `,
    variables: {
      slug: params.slug.join("/"),
    },
  }

  const subscription = await getSubscription(graphqlRequest)

  return {
    props: {
      key: params.slug.join("/"),
      options,
      seo,
      subscription,
    },
  }
}

export async function getStaticPaths() {
  const { records } = await getAllRecords(datoModels.INFO_PAGE, null, null, true)
  return {
    paths: records.map((page) => `/${page.slug}`),
    fallback: false,
  }
}

export default InfoPage
